import "./DroneCleaning.css";
import droneImg from "../../assets/dronenettoyage.jpg"; // ajoute une image dans /assets
import img1 from "../../assets/nettoyagedrone.jpeg";
import img2 from "../../assets/nettoyagedrone2.jpg";



export default function DroneCleaning() {
  const images = [img1, img2];
  return (
    <section className="drone-section container" id="nettoyage par drone">
      <div
        className="drone-card"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.6)), url(${droneImg})`,
        }}
      >
        <h2 className="drone-title">
          Nettoyage par Drone <span className="yellow">Haute Pression</span>
        </h2>

        <p className="drone-intro">
          Une technologie innovante pour un nettoyage rapide, sécurisé et efficace.
          Grâce à notre drone équipé d’un système haute pression à eau chaude, nous
          nettoyons les zones difficiles d’accès sans échafaudage ni nacelle.
        </p>

        <div className="drone-content">
          <div className="drone-box">
            <h3>Ce que nous faisons</h3>
            <ul>
              <li>Nettoyage de façades</li>
              <li>Nettoyage de toitures</li>
              <li>Nettoyage de bardages</li>
              <li>Nettoyage de panneaux solaires</li>
              <li>Nettoyage de grandes surfaces extérieures</li>
              <li>Entretien de bâtiments industriels ou commerciaux</li>
            </ul>
          </div>

          <div className="drone-box">
            <h3>Nos avantages</h3>
            <ul>
              <li>Sécurité maximale sans intervention en hauteur</li>
              <li>Efficacité grâce à la haute pression eau chaude</li>
              <li>Intervention rapide et sans matériel lourd</li>
              <li>Résultat professionnel et uniforme</li>
              <li>Accès aux zones complexes</li>
              <li>Réduction des coûts & du temps d’intervention</li>
            </ul>
          </div>
        </div>

        <p className="drone-bottom">
          <strong>Pourquoi choisir cette solution ?</strong>  <br />
          Elle réduit les risques, les coûts et améliore l’efficacité tout en garantissant un nettoyage profond et durable.
        </p>

        <div className="realisations-grid">
        {images.map((img, i) => (
          <div className="realisations-card" key={i} style={{ backgroundImage: `url(${img})` }}></div>
        ))}
      </div>
      <p className="texte-mail">
           📧 Email:{" "}
            <strong>
              <a href="mailto:cleandrone@outlook.com">cleandrone@outlok.com</a>
            </strong>
          </p>
      </div>

      
    </section>
  );
}